<template>
  <el-dialog
    title="删除推荐商品"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <div style="text-align: center;">
      <p>确定要删除该推荐商品吗？</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteProductLabel } from '@/api/goods/recommendGoodsApi'

export default {
  name: 'DeleteLabelProduct',
  data() {
    return {
      dialogVisible: false,
      currentProduct: null
    }
  },
  methods: {
    open(product) {
      this.currentProduct = product
      this.dialogVisible = true
    },

    async handleConfirm() {
      if (!this.currentProduct) return
      
      try {
        const res = await deleteProductLabel({
          productId: this.currentProduct.productId,
          labelCd: '8800012001'
        })
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.$emit('listProduct')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除商品标签失败:', error)
        this.$message.error('删除商品标签失败')
      } finally {
        this.dialogVisible = false
      }
    }
  }
}
</script>